<div *ngIf="accounts?.length; else notFound">
  <div [@openClose]="animationTrigger">
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{panelTitle}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="accounts">

        <ng-container matColumnDef="paidOn">
          <th mat-header-cell *matHeaderCellDef> 支払日 </th>
          <td mat-cell *matCellDef="let account"> {{account.paidOn | date: 'y/MM/dd'}} </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="paidBy">
          <th mat-header-cell *matHeaderCellDef> 支払人 </th>
          <td mat-cell *matCellDef="let account"> {{account.paidBy?.name}} </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="supplierName">
          <th mat-header-cell *matHeaderCellDef> お店 </th>
          <td mat-cell *matCellDef="let account">
            <a [routerLink]="getRouterLink(account)"> {{account.supplierName}} </a>
          </td>
          <td mat-footer-cell *matFooterCellDef> 合計 </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef> 金額 </th>
          <td mat-cell *matCellDef="let account"> {{account.amount | currency: 'JPY'}} </td>
          <td mat-footer-cell *matFooterCellDef> {{getTotalAmount(accounts) | currency: 'JPY'}} </td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef> 分類 </th>
          <td mat-cell *matCellDef="let account"> {{account.category?.name}} </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </mat-expansion-panel>
  </div>
</div>
<ng-template #notFound>
  <mat-card class="message">
    登録がありません。
  </mat-card>
</ng-template>